import { NudgeApprovalMeta, NudgeApprovalPayload } from 'types/store/NudgeApproval';
import { createAsyncReducer } from 'utils/Redux';

import { nudgeApprovalActions } from '../actions';

export default createAsyncReducer<NudgeApprovalMeta, NudgeApprovalPayload>(nudgeApprovalActions);
